import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const History = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M2.04999 13C2.55581 18.0351 6.83737 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C8.05498 2 4.62445 4.31518 3 7.65394L3 5L1 5V11H7V9L4.58701 9C5.77995 6.07513 8.6594 4 12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20C7.93849 20 4.55863 16.9326 4.06264 13H2.04999ZM12.4001 14.9L16.6001 12.9L15.7001 11.1L13.0001 12.4V7H11.0001V14L12.4001 14.9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default History;
